<template>
  <v-app>
    <v-parallax src="./assets/profile_background.jpg"
    id="about"
    dark
    >
    <v-row
    align="center"
    justify="center"
    class="mt-10">  
        <v-card
        class="mx-auto rounded-0 pa-4"
        max-width="100%"
        outlined>
          <v-row >
            <v-col
            style="padding:5%;"
            cols="4">
              <v-img
              :src="require('./assets/logo.png')"
              max-height="100%"
              max-width="90%"
              >

              </v-img>
            </v-col>
            <v-col
            cols="8">
              <p style="padding-top:2%; margin-bottom:0px;font-size: 200%;">I'm <strong>Anas Mohamed</strong></p>
              <p style="padding-top:0px; font-size: 80%;">Embedded and IoT Engineer</p>
              <v-divider></v-divider>
              <!-- <v-simple-table dense> -->
              <table>
                <tbody>
                  <tr >
                    <td style="font-size: 70%;"><strong>Age</strong></td>
                    <td style="width: 40px;"></td>
                    <td class="grey--text" style="font-size: 60%;">27</td>
                  </tr>
                   <tr >
                    <td style="font-size: 70%;"><strong>Address</strong></td>
                    <td></td>
                    <td class="grey--text" style="font-size: 60%;">Da Men Residences, USJ1, Subang Jaya, Malaysia</td>
                  </tr>
                   <tr >
                    <td style="font-size: 70%;"><strong>Email</strong></td>
                    <td></td>
                    <td class="grey--text" style="font-size: 60%;">anasmohamedshahid@gmail.com</td>
                  </tr>
                   <tr >
                    <td style="font-size: 70%;"><strong>Phone</strong></td>
                    <td></td>
                    <td class="grey--text" style="font-size: 60%;">+601114393271</td>
                  </tr>
                </tbody>
              </table>
              <!-- </v-simple-table> -->
            </v-col>
          </v-row>
          <v-row class="mt-4 mb-n4 ml-n4 mr-n4">
            <v-toolbar color="rgb(19, 141, 117, 0.4)" dense class="d-flex justify-space-around"> 
              <v-btn small icon plain @click="redirectGithub">
                <v-icon small>mdi-github</v-icon>
              </v-btn>          
              <v-btn small icon plain @click="redirectLinkedin">
                <v-icon small>mdi-linkedin</v-icon>
              </v-btn>
              
              <v-btn small icon plain @click="redirectInstagram">
                <v-icon small>mdi-instagram</v-icon>
              </v-btn>
              <v-btn small icon plain @click="redirectTwitter">
                <v-icon small>mdi-twitter</v-icon>
              </v-btn>
             
              <v-btn small icon plain @click="redirectFacebook">
                <v-icon small>mdi-facebook</v-icon>
              </v-btn>
            </v-toolbar>
          </v-row>
          
        </v-card>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-btn href="./assets/Anas_Mohamed_CV.pdf" color="rgb(17, 122, 101, 0.6)" class="white--text" >Download Resume</v-btn>
    </v-row>   
      <!-- </v-col>
    </v-row> -->
    </v-parallax>
    <v-app-bar app color="rgb(19, 141, 117, 0.4)" dark>
      <v-btn
        @click="$vuetify.goTo('#about')"
        target="_blank"
        text
      >
        <span class="mr-2">About</span>
      </v-btn>

      <v-spacer></v-spacer>

       <v-btn
        @click="$vuetify.goTo('#projects')"
        target="_blank"
        text
      >
        <span class="mr-2">Projects</span>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        @click="$vuetify.goTo('#skills')"
        target="_blank"
        text
      >
        <span class="mr-2">Skills</span>
      </v-btn>
     
    </v-app-bar>

    <v-main> 
      <div id="projects">
        <v-container width="100px;">
          
        
      <h1 class="d-flex justify-center">Projects</h1>
      <p class="d-flex justify-center subtitle-2 font-weight-light">A motley of some of my interests</p>
      <hr class="my-10">
      <!-- <div class="d-flex justify-center"> -->
        <!-- <div style="width:80%;"> -->
        <v-row >
          <v-col class="col-md-6 col-sm-12 col-xs-12">
            <v-hover v-slot:default="{ hover }">
            <v-card class="mx-auto"
              max-width="70%"
              >
              
              <v-img
                src="./assets/gamma.png"
                
                height="200px"
              >
                <v-expand-transition>
                  <div v-if="hover" class="d-flex text-center transition v-card--reveal white--text" style="height: 100%;font-size: 29px; "> <strong>A weaeable sensor to measure the spectral content of visible light</strong></div>
                </v-expand-transition>
              </v-img>
              <v-card-title class="justify-center">Wireless Spectral Sensor</v-card-title>
              <v-card-actions>
                <v-btn
                  color="rgb(19, 141, 117)"
                  text
                  @click="show = !show"
                >
                  Details
                </v-btn>
              </v-card-actions>
              <v-expand-transition>
              <div v-show="show">
                <v-divider></v-divider>

                <v-card-text class="text-left">
                  A wearable visible light spectral sensor. I was involved in the design, testing and calibration of this device. Working with a embedded system allowed me to extend my knowledge of embedded design and firmware development with tools such as KEIL uVision. I also got extensive knowledge on calibration of spectroradiometers and the metrology of light, Bluetooth Low Energy communication and memory management</v-card-text>
              </div>
            </v-expand-transition>
            </v-card>
            </v-hover>
          </v-col>
          <v-col class="col-md-6 col-sm-12 col-xs-12" >
            <v-hover v-slot:default="{ hover }">
            <v-card class="mx-auto"
              max-width="70%"
              >
              
              <v-img
                src="./assets/flutter.png"
                
                height="200px"
              >
                <v-expand-transition>
                  <div v-if="hover" class="d-flex text-center transition v-card--reveal black--text" style="height: 100%;font-size: 29px; "> <strong>An app made using Flutter to operate the sensor via Bluetooth</strong></div>
                </v-expand-transition>
              </v-img>
              <v-card-title class="justify-center">Flutter BLE App</v-card-title>
              <v-card-actions>
                <v-btn
                  color="rgb(19, 141, 117)"
                  text
                  @click="show2 = !show2"
                >
                  Details
                </v-btn>
              </v-card-actions>
              <v-expand-transition>
              <div v-show="show2">
                <v-divider></v-divider>

                <v-card-text class="text-left">
                  An app made using Flutter to connect to Wearable Spectral sensor. It can display basic information about the device, send commands to the device to take measurements and display the spectral measurements in graphical and numerical form. </v-card-text>
              </div>
            </v-expand-transition>
            </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row class="mt-4">
           <v-col  no-gutters class="col-md-6 col-sm-12 col-xs-12">
            <v-hover v-slot:default="{ hover }">
            <v-card class="mx-auto"
              max-width="70%"
              
              >
              
              <v-img
                src="./assets/IR.png"
                
                height="200px"
                
              >
                <v-expand-transition>
                  <div @click="redirectIR" v-if="hover" class="d-flex text-center transition v-card--reveal black--text" style="height: 100%;font-size: 29px; "> <strong>A website for Doctors and Patients</strong></div>
                </v-expand-transition>
              </v-img>
              <v-card-title class="justify-center">Stay @ Home Rehab</v-card-title>
              <v-card-actions>
                <v-btn
                  color="rgb(19, 141, 117)"
                  text
                  @click="show3 = !show3"
                >
                  Details
                </v-btn>
              </v-card-actions>
              <v-expand-transition>
              <div v-show="show3">
                <v-divider></v-divider>

                <v-card-text class="text-left">
                  A website made using plain PHP, CSS, JS and MySQL. It includes the frontend that allows doctors to view and modify data for their patients. The patients are intended to be patients who suffered a stroke. A wearble device is provided to them which collects data about the patient and transfers it to a database</v-card-text>
              </div>
            </v-expand-transition>
            </v-card>
            </v-hover>
          </v-col>
          <v-col  no-gutters class="col-md-6 col-sm-12 col-xs-12">
            <v-hover v-slot:default="{ hover }">
            <v-card class="mx-auto"
              max-width="70%"
              >
              
              <v-img
                src="./assets/generalBLE.png"
                
                height="200px"
              >
                <v-expand-transition>
                  <div @click="redirectWeble" v-if="hover" class="d-flex text-center transition v-card--reveal black--text" style="height: 100%;font-size: 29px; "> <strong>A website to connect to BLE devices</strong></div>
                </v-expand-transition>
              </v-img>
              <v-card-title class="justify-center">BLE WebApp</v-card-title>
              <v-card-actions>
                <v-btn
                  color="rgb(19, 141, 117)"
                  text
                  @click="show4 = !show4"
                >
                  Details
                </v-btn>
              </v-card-actions>
              <v-expand-transition>
              <div v-show="show4">
                <v-divider></v-divider>

                <v-card-text class="text-left">
                  A website made using Web Bluetooth and VueJs using Vuetify. It allows BLE devices to be searched and connected. Commands can be sent to the device and the responses recieved and displayed</v-card-text>
              </div>
            </v-expand-transition>
            </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row class="mt-4">
           <v-col  no-gutters class="col-md-6 col-sm-12 col-xs-12">
            <v-hover v-slot:default="{ hover }">
            <v-card class="mx-auto"
              max-width="70%"
              
              >
              
              <v-img
                src="./assets/iDash.jpg"
                
                height="200px"
                
              >
                <v-expand-transition>
                  <div v-if="hover" class="d-flex text-center transition v-card--reveal white--text" style="height: 100%;font-size: 29px; "> <strong>A long range Acoutic and Vibrational Sensor</strong></div>
                </v-expand-transition>
              </v-img>
              <v-card-title class="justify-center">Acoustic and Vibration sensor</v-card-title>
              <v-card-actions>
                <v-btn
                  color="rgb(19, 141, 117)"
                  text
                  @click="show5 = !show5"
                >
                  Details
                </v-btn>
              </v-card-actions>
              <v-expand-transition>
              <div v-show="show5">
                <v-divider></v-divider>

                <v-card-text class="text-left">
                  A telemetry sensor designed to be used on an oil rig. It is battery operated and communicates via LoRa. The device is controlled by an EFM32. I am involved in the PCB design, manufacturing and the development of the firmware of the device.</v-card-text>
              </div>
            </v-expand-transition>
            </v-card>
            </v-hover>
          </v-col>
          <v-col  no-gutters class="col-md-6 col-sm-12 col-xs-12">
            <v-hover v-slot:default="{ hover }">
            <v-card class="mx-auto"
              max-width="70%"
              >
              
              <v-img
                src="./assets/gammaWeb.png"
                
                height="200px"
              >
                <v-expand-transition>
                  <div @click="redirectGamma" v-if="hover" class="d-flex text-center transition v-card--reveal white--text" style="height: 100%;font-size: 29px; "> <strong>A website for the Flutter App</strong></div>
                </v-expand-transition>
              </v-img>
              <v-card-title class="justify-center">Website for the Spectral Sensor</v-card-title>
              <v-card-actions>
                <v-btn
                  color="rgb(19, 141, 117)"
                  text
                  @click="show6 = !show6"
                >
                  Details
                </v-btn>
              </v-card-actions>
              <v-expand-transition>
              <div v-show="show6">
                <v-divider></v-divider>

                <v-card-text class="text-left">
                  A website made using Laravel, VueJs and MySQL . It serves as a backend for the Flutter application. Data from the mobile app is sent to the backend. Users can login to the website and view their data</v-card-text>
              </div>
            </v-expand-transition>
            </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <!-- </div> -->
      <!-- </div> -->
      </v-container>
      </div> 
      <div style="background-color: rgb(19, 141, 117, 0.4); margin-top:80px;" id="skills">
        <v-container width="100px;">
          <h1 style="padding-top:80px;" class="d-flex justify-center">Skills</h1>
          <p class="d-flex justify-center subtitle-2 font-weight-light">A summary of what I can do</p> 
          <hr class="my-10">
          <v-container width="50%;" style="padding-right:200px; padding-left:200px;">
            <table style="width: 100%">
                <colgroup>
                  <col span="1" style="width: 50%;">
                  <col span="2" style="width: 50%;">
                </colgroup>
                
                
                
                <!-- Put <thead>, <tbody>, and <tr>'s here! -->
                <tbody>
                    <tr>
                        <td>PCB Design</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="50"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>PCB Assembly</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="70"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>Web Development</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="70"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>Mobile App Development</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="50"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>Keil uVision</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="80"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>OrCad PCB Design</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="60"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>Laravel</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="60"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>VueJs</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="80"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>Flutter</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="60"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>Embedded C</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="80"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>PHP</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="60"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>JavaScript</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="70"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>MySQL</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="40"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                    <tr>
                        <td>Python</td>
                        <td class="text-right">
                          <v-progress-linear
                          value="50"
                          color="rgb(19, 141, 117, 0.4)"
                          height="25"
                          ></v-progress-linear>
                        </td>
                    </tr>
                </tbody>
            </table>
          </v-container>
        </v-container>
      </div>
    </v-main>
  </v-app>
</template>

<script>
//import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",

  components: {
    //HelloWorld
  },

  data: () => ({
    show: false,
    show2:false,
    show3:false,
    show4:false,
    show5:false,
    show6:false,
  }),
  methods: {
    redirectIR(){
      window.open('https://www.provenpac.solutions/IR/');
    },
    redirectWeble(){
      window.open('https://ble.kirudhooni.com');
    },
    redirectGamma(){
      window.open('https://gamma.kirudhooni.com');
    },
    redirectGithub(){
      window.open('https://www.github.com/kirudhooni')
    },
    redirectLinkedin(){
      window.open('https://www.linkedin.com/in/anas-mohamed-545681198')
    },
    redirectInstagram(){
      window.open('https://www.linkedin.com/in/anas-mohamed-545681198')
    },
    redirectTwitter(){
      window.open('https://www.twitter.com/anasplt')
    },
    redirectFacebook(){
      window.open('https://www.facebook.com/anas.mohamed.9400')
    },
  }
};
</script>


<style lang="css">
.v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
}
ul {
  list-style-type: none;
 }
</style>